module.exports = __webpack_public_path__ + "static/amazingFeatureMobile-b94da82794632f6f57d18df0fe53b21f.svg";